import React, { useEffect, useState, Fragment } from "react";
import Layout from "components/sales/layoutChange/layout";
import TableSection from "components/sales/tableSection/tableSection";
import Images from "assets/images/imageData";
import "components/sales/layoutChange/layout.css";
import localization from "assets/localization/localization";
import { Button } from "react-bootstrap";
import ListFilters from "components/sales/ListFilters/ListFilters";
import {toast} from "react-toastify";

const HsnList = ({ getHsnList, hsnData = {} }) => {
  const headers = ["Name", "GST Code", "Type", "Description", "Status", "Created At"];

  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [selectedHsn, setSelectedHsn] = useState(false);
  const [selectedGst, setSelectedGst] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getHsnList(null, 1);
      setIsLoading(false);
    })();
  }, [getHsnList]);

  useEffect(() => {
    const tableData = ["name", "gst_name", "type", "description", "status", "created_at"];

    if (hsnData?.resultSets?.length > 0) {
        const data = hsnData.resultSets.map((element) =>
        Object.assign(
            {},
            ...tableData.map((key) => ({
            [key]:
                key === "status"
                ? element.status === 1
                    ? "Active"
                    : "Inactive"
                : element[key],
            })),
            {}
        )
        );

        setListData(data);
        setPageCount(Math.ceil(hsnData.total / hsnData.per_page));
    } else {
        setListData([]);
    }
    }, [hsnData]);

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getHsnList(filterData, val.selected + 1);
    setIsLoading(false);
  };

  const headerBtns = () => {
    return (
      <>
        <Fragment>
          <Button
            onClick={filterToggle}
            className="filter-hamburger btn btn-transparent"
          >
            <img src={Images?.Filter} alt=""></img>
            {localization.showFilters}
          </Button>
        </Fragment>
        <Fragment>
          <a
            href={`/dashboard/procurement/add_hsn`}
            className="filter-hamburger btn btn-primary borderColorBox colorBox filterButton"
          >
            + Add HSN/SAC
          </a>
        </Fragment>
      </>
    );
  };

  const applyFilter = async (filterData) => {

    const {hsn_code, gst_code} = filterData;

    if(!hsn_code && !gst_code){
      toast.error("Please select HSN or GST Code to filter");
      return false;
    }

    localStorage.setItem("hsn_filter", JSON.stringify(filterData));
    setIsLoading(true);
    setFilterData(filterData);
    await getHsnList(filterData, 1)
    setIsLoading(false);
    filterToggle();
  };

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  return (
    <Layout
      title="HSN/SAC List"
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <div className="row table-margin">
        <div className="col-md-12">
          <TableSection
            data={listData}
            isId={true}
            headers={headers}
            pageCount={pageCount}
            srNo={hsnData?.from}
            onPageChange={onPageChange}
          />
        </div>
        <ListFilters
          showFilter={showFilter}
          filterToggle={filterToggle}
          applyFilter={(val) => applyFilter(val)}
          setSelectedHsn = {setSelectedHsn}
          setSelectedGst = {setSelectedGst}
          hsnFilter
        />
      </div>
    </Layout>
  );
};

export default HsnList;
